export const GET_ROLE_REQUEST = '[ROLES] GET_ROLE_REQUEST'
export const GET_ROLE_SUCCESS = '[ROLES]GET_ROLE_SUCCESS'
export const GET_ROLE_FAILED = '[ROLES] GET_ROLE_FAILED'

export const GET_ROLE_LIST_REQUEST = '[ROLES] GET_ROLE_LIST_REQUEST'
export const GET_ROLE_LIST_SUCCESS = '[ROLES] GET_ROLE_LIST_SUCCESS'
export const GET_ROLE_LIST_FAILED = '[ROLES] GET_ROLE_LIST_FAILED'

export const CREATE_ROLE_REQUEST = '[ROLES] CREATE_ROLE_REQUEST'
export const CREATE_ROLE_SUCCESS = '[ROLES] CREATE_ROLE_SUCCESS'
export const CREATE_ROLE_FAILED = '[ROLES] CREATE_ROLE_FAILED'

export const EDIT_ROLE_REQUEST = '[ROLES] EDIT_ROLE_REQUEST'
export const EDIT_ROLE_SUCCESS = '[ROLES] EDIT_ROLE_SUCCESS'
export const EDIT_ROLE_FAILED = '[ROLES] EDIT_ROLE_FAILED'

export const DELETE_ROLE_REQUEST = '[ROLES] DELETE_ROLE_REQUEST'
export const DELETE_ROLE_SUCCESS = '[ROLES] DELETE_ROLE_SUCCESS'
export const DELETE_ROLE_FAILED = '[ROLES] DELETE_ROLE_FAILED'

export const ROLE_SEARCH_REQUEST = '[ROLES] ROLE_SEARCH_REQUEST'
export const ROLE_SEARCH_SUCCESS = '[ROLES] ROLE_SEARCH_SUCCESS'
export const ROLE_SEARCH_FAILED = '[ROLES] ROLE_SEARCH_FAILED'

export const GET_PERMISSION_LIST_REQUEST = '[ROLES] GET_PERMISSION_LIST_REQUEST'
export const GET_PERMISSION_LIST_SUCCESS = '[ROLES] GET_PERMISSION_LIST_SUCCESS'
export const GET_PERMISSION_LIST_FAILED = '[ROLES] GET_PERMISSION_LIST_FAILED'

export const RESET_ROLE_FORM = '[ROLES] RESET_ROLE_FORM';